/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { 
  useGET_setupOptionsQuery,
  usePOST_setupOptionEnableMutation,
  usePOST_setupOptionDisableMutation 
} from 'redux/api/setupApi'

import { Form, Formik } from 'formik'
import CheckboxField from 'components/atoms/fields/CheckboxField'

const CurriculumMapSetupForm: FC = () => {
  const { t } = useTranslation()
  
  const setupOptions = [
    {key: 'curriculum_student_learning_objectives', label: t('setup-curriculum.student-learning-objectives')},
    {key: 'curriculum_essential_questions', label: t('setup-curriculum.essential-questions')},
    {key: 'curriculum_enduring_understanding', label: t('setup-curriculum.enduring-understanding')},
    {key: 'curriculum_vocabulary', label: t('setup-curriculum.vocabulary')},
    {key: 'curriculum_instructional_strategies', label: t('setup-curriculum.instructional-strategies')},
    {key: 'curriculum_activities', label: t('setup-curriculum.activities')},
    {key: 'curriculum_assessment', label: t('setup-curriculum.assessment')},
    {key: 'curriculum_differentiation', label: t('setup-curriculum.differentiation')},
    {key: 'curriculum_reflection', label: t('setup-curriculum.reflection')},
    {key: 'curriculum_extensions', label: t('setup-curriculum.extensions')},
    {key: 'curriculum_family_connection', label: t('setup-curriculum.family-connection')},
    {key: 'curriculum_sequence', label: t('setup-curriculum.sequence')},
  ]


  const { data: setupData } = useGET_setupOptionsQuery()
  const [enableOption, {isLoading: isEnableLoading, isSuccess: isEnableSuccess, error: enableError}] = usePOST_setupOptionEnableMutation()
  const [disableOption, {isLoading: isDisableLoading, isSuccess: isDisableSuccess, error: disableError}] = usePOST_setupOptionDisableMutation()

  const serverValues = {
    options:
      setupData ? setupOptions.map(o => {
        return {
          ...o,
          is_enabled: setupData.filter(s => s.slug == o.key && s.is_enabled).length == 1
        }
      }) : []
  }


  return (

    <>{serverValues &&
    <Formik
      enableReinitialize
      initialValues={serverValues}
      onSubmit={(values) => {
      }}
    >
      {
        ({ values, setFieldValue, errors }) => 
        <Form>
          <Grid rowSpacing={4} columnSpacing={4} container alignSelf='baseline'>
            {values["options"].map((option,index) => 
              <Grid item xs={12} md={4} key={index}>
                <CheckboxField 
                  isSwitch={true}
                  hasLine={true}
                  index={index}
                  valueSelector='is_enabled'
                  fieldProps={{
                    label: option.label,
                    name: `options[${index}]`
                  }} 
                  onChange={(value)=> {
                    if(value.is_enabled)enableOption(option.key)
                    else disableOption(option.key)
                  }}
                />
              </Grid>
            )}
          </Grid>
        </Form>
      }
    </Formik>
    }</>
  )
}
export default CurriculumMapSetupForm

